<template>
  <div class="flex flex-col gap-2 sm:flex-row">
    <div
      class="flex-1 flex-row items-start gap-2"
      :class="$slots.subtitle ? 'flex' : 'hidden sm:flex'"
    >
      <div class="flex shrink-0 flex-col">
        <div class="hidden flex-row gap-2 sm:flex">
          <h2 class="text-2xl font-bold capitalize-first">
            {{ getTitle }}
          </h2>
          <div class="flex flex-1 items-center">
            <span
              v-if="auth.id === dashboard.creator_id"
              class="rounded-md border border-gray-600 px-2 py-0.5 text-xs font-medium dark:border dark:border-white dark:bg-slate-700 dark:text-white"
            >
              {{
                dashboard.public ? $t('global.public') : $t('global.private')
              }}
              <FontAwesomeIcon
                v-if="dashboard.public"
                :icon="['fal', dashboard.locked ? 'lock' : 'lock-open']"
              />
            </span>
            <template v-else-if="!dashboard.public">
              <AvatarComponent :user_id="dashboard.creator_id" size="8" />
            </template>
          </div>
        </div>
        <div v-if="$slots.subtitle">
          <slot name="subtitle" />
        </div>
      </div>
    </div>
    <div class="flex flex-shrink-0 flex-row gap-2">
      <slot name="cta"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AvatarComponent from '@c/AvatarComponent.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DashboardHeader',
  components: { FontAwesomeIcon, AvatarComponent },
  props: {
    dashboard: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth'
    }),
    getTitle() {
      return (
        this.dashboard.name[this.$i18n.locale] ??
        this.$t('navigation.statistics_title')
      )
    }
  }
}
</script>

<style scoped></style>
